import { Box, Grid } from "@mui/material";
import { ButtonSidebar } from "../Behelit/ButtonSidebar";
import { FaClipboardList, FaHome, FaIdCard } from "react-icons/fa";
import { BsJournalBookmarkFill } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { LuAlarmClock } from "react-icons/lu";
import { RiImageAddLine } from "react-icons/ri";

export const SidebarIcons: React.FC<{ isAuth: boolean, userRoles?: Array<string>; }> = ({ isAuth, userRoles = [] }) => {
    const navigate = useNavigate();
    const location = useLocation();
    
    const GoTo = (site: string) => {
        navigate(site);
    };

    return (
        <Box sx={{
            overflowY: 'auto',
            overflowX: 'hidden',    // oculta scroll horizontal
            direction: 'rtl', // Mueve scroll a la izquierda
            '& > *': {
                direction: 'ltr', // Mantiene el contenido normal
            },
            '&::-webkit-scrollbar': {
                width: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888',
                borderRadius: '4px',
            },
        }}>
            <Grid container direction="column" justifyContent="center" alignItems="center" spacing={{ xs: 3, md: 6, lg: 6, xl: 6 }} columns={{ xs: 2, sm: 2, md: 4, lg: 2, xl: 2 }}>
                {/* <Grid item key={'cerrar-sidebar'}>
                                    <IconButton
                                        sx={{
                                            color: themePalette.COLOR_SIDEBAR_ICON,
                                        }}
                                        onClick={toggleDrawer}
                                    >
                                        <IoIosCloseCircleOutline size={size} />
                                    </IconButton>
                                </Grid> */}
                <Grid item key={'home-00'}>
                    <ButtonSidebar nombre="Home" GoTo={() => GoTo('/general')} sinTexto={false} isActive={location.pathname === '/general'}>
                        <FaHome />
                    </ButtonSidebar>
                </Grid>
                {isAuth ?
                    <Grid item key={'historico-01'}>
                        <ButtonSidebar nombre="Historial" GoTo={() => GoTo('/general/historial')} sinTexto={false} isActive={location.pathname === '/general/historial'}>
                            <LuAlarmClock />
                        </ButtonSidebar>
                    </Grid>
                    : <></>}
                {isAuth && userRoles.includes('Creador') ?
                    <>
                        <Grid item key={'miscomunicados-01'}>
                            <ButtonSidebar nombre="Mis Comunicados" GoTo={() => GoTo('/creator/miscomunicados')} sinTexto={false} isActive={location.pathname === '/creator/miscomunicados'}>
                                <FaClipboardList />
                            </ButtonSidebar>
                        </Grid>
                        <Grid item key={'crear-01'}>
                            <ButtonSidebar nombre="Crear Comunicados" GoTo={() => GoTo('/creator/addanuncio')} sinTexto={false} isActive={location.pathname === '/creator/addanuncio'}>
                                <RiImageAddLine />
                            </ButtonSidebar>
                        </Grid>
                    </>
                    : <></>}
                {isAuth && userRoles.includes('Revisor') ? (
                    <>
                        {/* <Grid item key={'plantilla-01'}>
                                        <ButtonSidebar nombre="Plantillas" GoTo={() => GoTo('/plantillas')} sinTexto={false} isActive={location.pathname === '/plantillas'}>
                                            <img src={PlantillasIcon} alt="Plantillas Section" style={{ width: '20px', height: 'auto' }} />
                                        </ButtonSidebar>
                                    </Grid>
                                    <Grid item key={'campania-01'}>
                                        <ButtonSidebar nombre="Campañas" GoTo={() => GoTo('/campanias')} sinTexto={false} isActive={location.pathname === '/campanias'}>
                                            <img src={CampaniasIcon} alt="Campañas Section" style={{ width: '20px', height: 'auto' }} />
                                        </ButtonSidebar>
                                    </Grid> */}
                        <Grid item key={'aprobar-01'}>
                            <ButtonSidebar nombre="Revisor" GoTo={() => GoTo('/reviewer')} sinTexto={false} isActive={location.pathname === '/reviewer'}>
                                <BsJournalBookmarkFill />
                            </ButtonSidebar>
                        </Grid>
                        {/* <Grid item key={'config-01'}>
                                        <ButtonSidebar nombre="Configuración" GoTo={() => GoTo('/config')} sinTexto={false} isActive={location.pathname === '/config'}>
                                            <BsGearFill />
                                        </ButtonSidebar>
                                    </Grid> */}
                    </>
                ) : (<></>)}
                {userRoles.includes('Administrador') ? (
                    <Grid item key={'admin-01'}>
                        <ButtonSidebar nombre="Administrador" GoTo={() => GoTo('/admin')} sinTexto={false} isActive={location.pathname === '/admin'}>
                            <FaIdCard />
                        </ButtonSidebar>
                    </Grid>
                ) : (<></>)}
            </Grid>
        </Box>
    );
}